export default {
    login: {
        pleaseLogin: '请登录',
        username: '用户名',
        password: '密码',
        login: '登录',
        passwordTooShort: '密码长度小于{len}'
    },
    footer: {
        copyRight: '苏南瑞丽航空有限公司版权所有',
        versionUpdate: '版本更新'
    },
    head: {
        title: 'App分发平台',
        staffReport: '员工自愿报告',
        messageList: '消息列表',
        message: '消息',
        sso: '瑞航通',
        logout: '退出',
        setRead: '设为已读',
        setAllRead: '全部已读',
    },
    route: {
        dashboard: '首页',
        version: '版本更新',
        AppInfo: '应用信息管理',
        EventDictionary: '事件字典维护',
        EventLogInfo: '事件记录',
        deviceDeliverReturn: '设备放发回收',
        deviceDeliver: '任务发放',
        devBackGround: '开发训练场',
        errorPage: '错误界面',
        curd: '增删查改',
        error404: '404',
        error401: '401',
        App: '应用管理',
        Device: '设备信息查询',
        Event: '应用事件管理',
        Package: '应用版本管理',
        AppCrashLog: '崩溃日志查询',
        AppDeviceInfo: '设备应用注册查询',
        DownLoadLog: '应用下载查询',
        EventLog: '事件查询',
        Log: '通用日志查询',
        UserActivityStatistics: '日活跃统计',
        UserDownloadStatistics: '用户下载更新统计',
        UserActivitySectionStatistics: '月活跃统计',
        ConfigInfo: '配置管理',
        DataDictionaryInfo: '数据字典'
    },
    //组件管理
    component: {
        table: {
            chineseName: '小部件中文名',
            englishName: '小部件英文名',
            dynamic: '组件',
            englishDescription: '小部件英文描述',
            chineseDescription: '小部件中文描述',
            width: '宽',
            height: '高'
        }

    },
    roleManagement: {
        enabled: '启用',
        disabled: '禁用',
        code: '代码',
        name: '名称',
        roleType: '角色类型',
        state: '状态',
        description: '描述',
        language: '语言',
        roleName: '角色名称',
        dataType: '数据权限类型',
    },
    navbar: {
        logOut: '退出登录',
        dashboard: '首页',
        screenfull: '全屏',
        theme: '换肤',
    },
    tagsView: {
        close: '关闭',
        closeOthers: '关闭其它',
        closeAll: '关闭所有',
    },
    common: {
        submit: '提交',
        serialNumber: '序号',
        addSameLevel: '添加（同级）',
        addNextLevel: '添加（下级）',
        delete: '删除',
        new: '新建',
        edit: '编辑',
        detail: '详情',
        warning: '提示',
        noData: '暂无数据',
        selectNodata: '请先选择待操作数据',
        selectMore: '请选择多条操作数据',
        selectMultiple: '只允许对一条进行操作',
        creater: '创建人',
        createTime: '创建时间',
        updateUser: '更新人',
        updateDate: '更新时间',
        isDeleted: '是否删除',
        handle: '处理',
        operateSuccess: '操作成功！',
        operateFailed: '操作失败！',
        search: '查询',
        addNew: '新增',
        addBatch: '批量新增',
        reset: '重置',
        open: '展开',
        selectA: '请选择',
        confirmRefresh: '确认刷新？',
        confirmDelete: '确认删除？',
        confirmCommit: '确认提交？',
        confirmCancel: '确认取消？',
        confirmClose: '确认关闭？',
        confirmOpen: '确认打开？',
        yes: '确定',
        confirm: '确认',
        save: '保存',
        cancel: '取消',
        cancelDelete: '取消删除',
        close: '关闭',
        select: '请选择{item}',
        input: '请输入{item}',
        more: '更多条件',
        fold: '折叠',
        addFile: '添加文件',
        uploFile: '开始上传',
        refreshAllCache: '刷新所有权限缓存',
        operate: {
            success: '成功',
            failed: '操作失败'
        },
        yesno: {
            1: '是',
            0: '否',
        },
        table: {
            keyword: '关键字',
        },
        revoke: '撤回',
        place: '管理站点',
        flightDate: '航班日期',
        userName: '机组姓名',
        flightNo: '航班号',
        plane: '飞机',
        require: '必填',
        phone: '电话',
        isGray: '灰度标识',
        name: '姓名',
        technicName: '技术级别',
        trips: '航程',
        ptd: '离港时间',
        pta: '到港时间',
        Creater: '创建人',
        CreateTime: '创建时间',
        Updater: '修改人',
        UpdateTime: '修改时间',
        IsDeleted: '是否删除',

        beginTime: '开始时间',
        endTime: '结束时间',
        export: '导出',
        downloadFail: '下载失败'
    },
    // 数据字典
    dataDictionary: {
        dataCode: '编码',
        dataName: '名称',
        dataEnglishName: '英文名称',
        rank: '排序',
        isModify: '可修改类型',
        extraInfo: '扩展信息',
        ramark: '备注',
        updater: '更新人',
        updateTime: '更新时间',
        creater: '创建人',
        createTime: '创建时间',
        noOperation: '此数据不能操作',
    },
    //权限管理
    authManagement: {
        basic: '基本信息',
        code: '代码',
        parentCode: '父节点代码',
        parentCodeNone: '父节点不存在',
        uri: '节点地址',
        languageType: '语言类别',
        name: '名称翻译',
        description: '描述翻译',
        menu: '菜单信息',
        showType: '显示类型',
        styleClassName: '样式名称',
        icon: '图标',
        optionList: '扩展信息',
        tabsViewName: '选择卡名称翻译',
        menuViewName: '菜单名称翻译',
        addCode: '添加节点',
        editCode: '修改节点',
        // table: {
        //     editCode: 'ss'
        // }
    },
    menuManagement: {
        languageType: '语言类别',
        name: '名称',
        rank: '排序',
        isShow: '是否显示',
        menuViewName: '菜单名',
        tabsViewName: '标签名',
        uri: '地址',
        parentUri: '父级地址',
        addCode: '添加菜单',
        editCode: '编辑菜单',
        parentCodeNone: '没有找到父节点',
        typeError: '类型错误',
    },
    //用户管理
    userManagement: {
        account: '用户账号',
        type: '用户类型',
        rank: '排序',
        state: '启用状态',
        isDeleted: '是否删除',
        tipNotAllowEdit: '不允许修改该用户',
        language: '语言',
        password: '用户密码',
        name: '名称',
        extraInfo: '附加消息',
        key: '键',
        value: '值',
        action: '操作',
        placeholder: {
            password: '留空表示不修改密码',
        },
        //userManagement.placeholder.password
    },
    //用户授权
    userAuthorization: {
        name: '姓名',
        mobile: '移动电话',
        account: '账号',
        email: '邮箱',
        globalSearch: '全局搜索',
        organization: '(组织机构)',
        user: '(用户)',
    },
    //首页
    mainHome: {
        chart: {
            stationEquipment: '站点设备情况',
            status: '状态',
            overallEquipment: '设备总体情况',
            deviceGrayscale: '设备灰度设置',
            overDueDevice: '逾期未还设备',
            code: '设备号',
            responsibleUserName: '责任人',
            phone: '电话',
            DeliverTime: '发放时间',
            returnTime: '预计归还时间',
            PurposeName: '备注',
            userActivity: '用户活跃统计',
            appId: '应用名称',
            type: '统计维度',
            numberOfAppStart: '启动次数',
            deviceActivity: '设备活跃统计'
        },
        index: {
            layoutDialogTitle: '选择小部件',
            layoutDialogWidgetName: '小部件名称',
            layoutDialogWidgetDescription: '小部件描述',
            layoutActionEditBtn: '添加组件'
        }
    },
    //配置信息
    configInfo: {
        code: '代码',
        name: '名称',
        isHide: '是否隐藏',
        rank: '排序',
        updaterName: '更新人',
        updateTime: '更新时间',
        createrName: '创建人',
        createTime: '创建时间',
        value: '值',
    },
    file: {
        name: '文件名',
        beginTime: '生效开始时间',
        endTime: '生效结束时间',
        ChOrEn: '语言类别',
        uploadTime: '上传时间',
        uploader: '上传人',
        upload: '文件上传',
        selectFile: '选择文件',
        selectFilePlease: '请选择上传文件',
        status: '文件状态',
    },
    //应用信息管理
    appInfo: {
        code: '应用编码',
        name: '应用名称',
        des: '应用描述',
        englishName: '应用英文名',
        englishDes: '应用英文描述',
        isEnterpriseApp: '是否为本企业应用',
        createrName: '创建人',
        appAccount: '应用账号',
        createTime: '创建时间',
        baseInfo: '基础信息',
        selectLogo: '选择文件',
        isJPG: '请上传jpg图片',
        xiaoMiAppId: '小米AppId',
        xiaoMiAppSecret: '小米AppSecret',
        huaWeiAppId: '华为AppId',
        huaWeiAppSecret: '华为AppSecret',
        pushCertificate: '苹果推送证书',
        pushCertificatePassword: '推送证书密码',
        apnsTeamId: '苹果 Teamid',
        apnsKeyId: '苹果 KeyId',
        apnsPrivateKey: '苹果 PrivateKey'
    },
    //事件字典维护
    eventDictionary: {
        appName: '应用名称',
        code: '事件代码',
        name: '事件名称',
        updater: '修改人',
        updateTime: '修改时间',
    },
    //事件记录管理
    eventLogInfo: {
        eventName: '事件名称',
        appName: '应用名称',
        deviceName: '设备Id',
        version: '版本号',
        userAccount: '用户账号',
        eventCreatedTime: '事件创建时间',
        startTime: '事件创建开始时间',
        endTime: '事件创建结束时间',
        machineId: '设备Id',
        model: '设备型号',
        manufacturer: '厂商',
        osType: '系统平台类型',
        eventRemark: '事件备注'
    },
    //崩溃日志
    appCrashLog: {
        appCrashTime: '崩溃时间',
        appCode: '应用编码',
        appName: '应用名称',
        machineId: '设备Id',
        versionCode: '版本号',
        manufacturer: '厂商',
        model: '设备型号',
        osVersion: '操作系统',
        detail: '崩溃日志明细',
        downloadLog: '下载日志'
    },
    //设备应用注册统计
    appDeviceInfo: {
        appName: '应用名称',
        deviceName: '设备Id',
        version: '版本号',
        userAccount: '用户账号',
        registerTime: '注册时间',
        isValid: '是否有效',
        manufacturer: '厂商',
        model: '设备型号',
        osType: '系统平台类型',
        token: '设备标识'
    },
    package: {
        appId: '应用id',
        app: '应用名称',
        appStoreUrl: '应用下载地址',
        appStoreUrlPlaceHolder: '如填写，则以填写的地址为准；否则由后台计算给出默认的下载地址',
        fileId: '文件id',
        fileMd5: '文件md5',
        fileName: '文件名',
        fileSize: '文件大小',
        isForceUpdate: '是否强制更新',
        osType: '系统平台类型',
        versionCode: '版本号',
        versionName: '版本名',
        updateDes: '更新内容描述',
        updateEnglishDes: '更新内容英文描述',
        isPublished: '是否发布',
        addPackage: '上传版本',
        editPackage: '修改版本',
        detail: '详情',
        publish: '版本发布',
        downloadFile: '下载版本',
        tabOfPackage: '版本信息',
        tabOfPublish: '发布信息',
        creater: '上传人',
        createTime: '上传时间',
        cancelPublishPackage: '取消发布',
        cancelPublishConfirm: '确认取消发布?',
        submitBeforeSavePackage: '必须先上传应用后再进行保存',
        formula: '版本号格式错误',
        userFormula: '账号格式错误',
        machineFormula: '设备格式错误'
    },
    publishRule: {
        isAll: '是否全量发布',
        userAccounts: '账号',
        machineIds: '设备'
    },
    downloadLogInfo: {
        appName: '应用名称',
        deviceName: '设备型号',
        versionCode: '版本号',
        machineId: '设备Id',
        package: '版本号',
        userAccount: '用户账号',
        ip: 'IP地址',
        channel: '渠道',
        createTime: '创建时间',
        osType: '系统平台类型'
    },
    device: {
        machineId: '设备Id',
        model: '设备型号',
        manufacturer: '厂商',
        osType: '系统平台类型',
        osVersion: '操作系统',
        lastUserAccount: '最后登录账号'
    },
    appLog: {
        logCode: '日志编码',
        appCode: '应用编码',
        PackageId: '包id',
        versionCode: '版本号',
        machineId: '设备Id',
        userAccount: '用户账号',
        logCreateTime: '日志生成时间',
        content: '内容',
        appName: '应用名称'
    },
    userActivityStatistics: {
        app: '应用名称',
        osType: '系统平台类型',
        version: '版本号',
        userCount: '活跃用户数',
        deviceCount: '活跃设备数',
        startTime: '开始时间',
        endTime: '截止时间',
        userLoginCount: '用户登录次数',
        model: '设备型号',
        timeRange: '活跃区间',
        date:'日期'
    },
    userDownloadStatistics: {
        app: '应用名称',
        osType: '系统平台类型',
        version: '版本号',
        newDeviceCount: '新增设备数',
        newUserCount: '新增用户数',
        deviceCount: '下载设备数',
        newDownloadCount: '累计下载次数(新下载)',
        updateCount: '累计下载次数(版本更新)',
        total: '累计下载次数(合计)',
        startTime: '开始时间',
        endTime: '截止时间',
        model: '设备型号'
    },
    advice: {
        appId: '应用',
        appCode: '应用',
        packageId: '版本',
        content: '意见内容',
        ip: '反馈提交时的ip地址',
        account: '用户账号',
        contact: '联系方式'
    }
};
